import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './SendOTP.css';
import Modal from '../../components/Modal/Modal';

const API_URL = process.env.REACT_APP_API_URL;

const SendOTP = () => {
    const [username, setUser] = useState('');
    const navigate = useNavigate();
    const [modalData, setModalData] = useState({
        isVisible: false,
        message: '',
        type: '',
    });

    const handleRestore = async (event) => {
        event.preventDefault();

        const userData = {
            username: username,
        };

        try {
            const response = await fetch(`${API_URL}/accounts/send-otp`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(userData),
            });
            if (response.ok) {
                const data = await response.json();
                setModalData({
                    isVisible: true,
                    message: data.message,
                    type: 'success',
                });
                const timer = setTimeout(() => {
                    navigate('/check-otp', { state: { username } });
                }, 2000);
                return () => clearTimeout(timer);
            } else if (response.status === 404) {
                const errorData = { "error": "نام کاربری وجود ندارد" }
                setModalData({
                    isVisible: true,
                    message: errorData.error,
                    type: 'error',
                });
            } else {
                const errorData = await response.json();
                setModalData({
                    isVisible: true,
                    message: errorData.error,
                    type: 'error',
                });
            }
        } catch (error) {
            setModalData({
                isVisible: true,
                message: 'مشکلی پیش آمده است. لطفا دوباره تلاش کنید',
                type: 'error',
            });
        }
    };

    return (
        <div className="container">
            <div className="restore-form-container">
                <h2 className='restore-title'>بازنشانی رمز</h2>
                <form onSubmit={handleRestore}>
                    <div className="restore-form-group">
                        <label className="restore-label">نام کاربری</label>
                        <input
                            type="text"
                            value={username}
                            onChange={(event) => setUser(event.target.value)}
                            required
                            className="restore-input"
                        />
                    </div>
                    <button type="submit" className="restore-button btn medium-text">
                        ارسال کد
                    </button>
                </form>
                <Modal
                    message={modalData.message}
                    type={modalData.type}
                    isVisible={modalData.isVisible}
                    onClose={() => setModalData({ ...modalData, isVisible: false })}
                />
            </div>
        </div>
    );
};

export default SendOTP;
